import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import styled, { useTheme } from "styled-components";
import { IconButton, Logo } from "@miro-site/core";
var HeaderLogoBase = function(_param) {
    var href = _param.href, className = _param.className, restProps = _object_without_properties(_param, [
        "href",
        "className"
    ]);
    var theme = useTheme();
    var _color = restProps.color, color = _color === void 0 ? theme.header.logo.color : _color;
    return /*#__PURE__*/ _jsx(IconButton, _object_spread({
        icon: /*#__PURE__*/ _jsx(Logo, {
            $styles: {
                width: theme.header.logo.width,
                height: theme.header.logo.height,
                color: color,
                transition: "color 250ms ease"
            }
        }),
        label: "Miro Logo",
        href: href,
        className: className,
        title: "Go to the main page"
    }, restProps));
};
var HeaderLogo = styled(HeaderLogoBase).withConfig({
    componentId: "sc-7b3c8f38-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.normalizeStyles({
        width: theme.header.logo.width,
        height: theme.header.logo.height,
        position: "relative",
        top: theme.header.logo.offset.top
    });
});
export default HeaderLogo;
